module.exports = __webpack_public_path__ + "static/img/rules.8edadea9.png";